export default {
  "zh-CN": {
    settingsUi: {
      streamerAccess: "主播权限申请",
      streamerAccessTip: "通过公会、经纪人或官方邮箱申请",
      streamerAccessNoticeTitle: "如何申请主播权限",
      streamerAccessNotice: "请联系你所在的公会或经纪人，或发送邮件至 {email} 加入我们的公会。"
    },
    centerUi: { works: "作品" },
    studioUi: { creatorApplicationClosed: "短视频创作者申请已关闭。" }
  },
  "en-US": {
    settingsUi: {
      streamerAccess: "Live host application",
      streamerAccessTip: "Apply through your guild, agent, or the official email",
      streamerAccessNoticeTitle: "How to apply for live access",
      streamerAccessNotice: "Contact your guild or agent, or email {email} to join our guild."
    },
    centerUi: { works: "Works" },
    studioUi: { creatorApplicationClosed: "Short-video creator applications are no longer available." }
  },
  "vi-VN": {
    settingsUi: {
      streamerAccess: "Đăng ký quyền phát trực tiếp",
      streamerAccessTip: "Đăng ký qua công hội, người quản lý hoặc email chính thức",
      streamerAccessNoticeTitle: "Cách đăng ký quyền phát trực tiếp",
      streamerAccessNotice: "Hãy liên hệ công hội hoặc người quản lý của bạn, hoặc gửi email đến {email} để gia nhập công hội của chúng tôi."
    },
    centerUi: { works: "Tác phẩm" },
    studioUi: { creatorApplicationClosed: "Đăng ký nhà sáng tạo video ngắn đã đóng." }
  },
  "ar-SA": {
    settingsUi: {
      streamerAccess: "طلب صلاحية البث",
      streamerAccessTip: "قدّم عبر النقابة أو الوكيل أو البريد الرسمي",
      streamerAccessNoticeTitle: "كيفية طلب صلاحية البث",
      streamerAccessNotice: "تواصل مع نقابتك أو وكيلك، أو أرسل بريدًا إلى {email} للانضمام إلى نقابتنا."
    },
    centerUi: { works: "الأعمال" },
    studioUi: { creatorApplicationClosed: "لم تعد طلبات منشئ الفيديو القصير متاحة." }
  }
}
